"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.CSQ8;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "",
  inline: false
};
var clientSatisfactionQuestions = [{
  prompt: "How would you rate the quality of service you received? ",
  // extraText: "",
  type: "radio",
  options: ["Poor", "Good", "Fair", "Excellent"],
  key: "qualityOfService",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Did you get the kind of service you wanted?",
  type: "radio",
  options: ["No, definitely not", "No, not really", "Yes, generally", "Yes, definitely"],
  key: "kindOfService",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "To what extent has our service met your needs?",
  type: "radio",
  options: ["None of my needs have been met", "Only a few of my needs have been met", "Most of my needs have been met", "Almost all of my needs have been met"],
  key: "serviceMetNeeds",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "If a friend were in need of similar help, would you recommend our service to him or her?",
  // extraText: "",
  type: "radio",
  options: ["No, definitely not", "No, I don’t think so", "Yes, I think so", "Yes, definitely"],
  key: "recommendService",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "How satisfied are you with the amount of help you received?",
  // extraText: "",
  type: "radio",
  options: ["Quite dissatisfied", "Indifferent or mildly dissatisfied", "Mostly satisfied", "Very satisfied"],
  key: "satisfied",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Have the services you received helped you to deal more effectively with your problems?",
  // extraText: "",
  type: "radio",
  options: ["No, they seemed to make things worse", "No, they really didn’t help", "Yes, they helped somewhat", "Yes, they helped a great deal"],
  key: "helped",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "In an overall, general sense, how satisfied are you with the service you received?",
  // extraText: "",
  type: "radio",
  options: ["Quite dissatisfied", "Indifferent or mildly dissatisfied", "Mostly satisfied", "Very satisfied"],
  key: "satisfiedService",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "If you were to seek help again, would you come back to our service? ",
  // extraText: "",
  type: "radio",
  options: ["No, definitely not", "No, I don’t think so", "Yes, I think so", "Yes, definitely"],
  key: "again",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Write any comments below",
  // extraText: "",
  description: "This survey uses items and item responses from the Client Satisfaction Questionnaire© by permission of the copyright holder.  Copyright©2019. Clifford Attkisson, Ph.D.  Use, transfer, copying, reproduction, merger, translation, modification, or enhancement (in anyversion, format, and/or media including electronic), in whole or in part, is forbidden without written permission by Dr. Attkisson. Contact: Info@CSQscales.com.",
  type: "textarea",
  optional: true,
  key: "comments",
  eval: function _eval(n) {
    return n;
  }
}];
var questions = (0, _utils.wrapBattery)(clientSatisfactionQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    CSQ8: score,
    CSQ8_1: answers[0],
    CSQ8_2: answers[1],
    CSQ8_3: answers[2],
    CSQ8_4: answers[3],
    CSQ8_5: answers[4],
    CSQ8_6: answers[5],
    CSQ8_7: answers[6],
    CSQ8_8: answers[7]
  };
}